import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { shouldForwardProp } from '@ori/presentation-utils';
import { lighten, styled } from '@ori-ui/mui';
export var getFontSize = function getFontSize(size) {
  switch (size) {
    case 'large':
      return 14;
    case 'medium':
      return 12;
    default:
      return 10;
  }
};
export var getBottomTopPadding = function getBottomTopPadding(size) {
  return size === 'small' ? 0.4 : 1;
};
export var getHeight = function getHeight(size) {
  switch (size) {
    case 'large':
      return 32;
    case 'medium':
      return 28;
    default:
      return 20;
  }
};
export var Root = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(function (_ref) {
  var isEmpty = _ref.isEmpty,
    isNegative = _ref.isNegative,
    size = _ref.size,
    theme = _ref.theme;
  return _objectSpread({
    alignItems: 'center',
    background: theme.palette.grey[100],
    color: theme.palette.default.main,
    display: 'flex',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(getFontSize(size)),
    fontWeight: theme.typography.fontWeightBold,
    height: isEmpty ? getHeight(size) : undefined,
    justifyContent: 'center',
    padding: theme.spacing(getBottomTopPadding(size), 0),
    textTransform: 'uppercase'
  }, isNegative && {
    background: lighten(theme.palette.error.light, 0.88),
    color: theme.palette.error.dark
  });
});
//# sourceMappingURL=styles.js.map